import { historyItemCommentWithSource as commentWithSource, isRobotHistoryItem, pdaCommentHistoryItems, robotHistoryFieldLabel } from "../../../utils/patientHistory";
import { FIELD_LABELS } from "./administrationConstants";

export { isRobotHistoryItem, pdaCommentHistoryItems };

export function historyFieldLabel(fieldName) {
    return robotHistoryFieldLabel(fieldName) || FIELD_LABELS[fieldName] || fieldName;
}

export function historyItemCommentWithSource(item) {
    return commentWithSource(item, "admin");
}
